export default class SelectedTermostatProducts {
  mixPoints = 0 as number
  pcs: Record<string, number> = {
    'WH-TZV4B': 0,
    'WH-TZV4': 0
  }

  pro2: string[] = []
  tech: string[] = []
  heatmiser: string[] = []
  techAccessory: string[] = []
  techWirelessAccessory: string[] = []
}
